import {
  fromTimestamp,
  dateFormatter,
  formatStandardDateStrings
} from '../../../helpers/formatTime';

const ONE_HOUR = 60 * 60 * 1000;

export function formatDisplayTime(
  timestamp: number,
  timezone: string,
  dateTimeFormat: string,
  timeFormat: string,
  includeDate: boolean = false
): string {
  const localMoment = fromTimestamp(timestamp);
  let localTime: string;
  if (includeDate) {
    const dateTimeFormatFn = dateFormatter(dateTimeFormat);
    [localTime] = formatStandardDateStrings(dateTimeFormatFn, localMoment, timezone);
  } else {
    const timeFormatFn = dateFormatter(timeFormat);
    [localTime] = formatStandardDateStrings(timeFormatFn, localMoment, timezone);
  }

  return localTime;
}

export function isSameDay(timestamp1: number, timestamp2: number, timezone: string): boolean {
  const localMoment1 = fromTimestamp(timestamp1).tz(timezone);
  const localMoment2 = fromTimestamp(timestamp2).tz(timezone);
  return localMoment1.isSame(localMoment2, 'day');
}

export function formatDuration(startTimeStamp: number, endTimeStamp: number): string {
  const duration = endTimeStamp - startTimeStamp;
  if (duration - ONE_HOUR > 0) {
    return `${(duration / ONE_HOUR).toFixed(1)} hrs`;
  } else {
    return `${(duration / 60000).toFixed(0)} mins`;
  }
}
